export default __webpack_public_path__ + "static/media/topic900_tip.e8ddb23e.svg";